import { ApiResponse, TokenData } from "../models";
import { DecisionTimeFrame } from "../models/decisionTimeFrame";

import * as http from "./http";
import ApiService from "./service";

export class DecisionTimeFrameService extends ApiService {
  public async loadAllDecisionTimeFrame() {
    const url = `${this.apiDomain}/api/decision-timeframe`;

    const resposne = await http.get<ApiResponse<DecisionTimeFrame[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDecisionTimeFrame(data: DecisionTimeFrame) {
    const url = `${this.apiDomain}/api/decision-timeframe`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateDecisionTimeFrame(data: DecisionTimeFrame, id?: string) {
    const url = `${this.apiDomain}/api/decision-timeframe/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteDecisionTimeFrame(id?: string) {
    const url = `${this.apiDomain}/api/decision-timeframe/${id}`;

    const response = await http.remove<ApiResponse<TokenData>>(url, this.store);
    return response.data;
  }
}
